import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import AuthHeader from "./AuthHeader";
import TermsPopup from "./TermsAndConditions";
import { getGoogleAuthUrl } from "./googleAuth";

const EyeIcon = ({ closed = false }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="h-5 w-5"
    aria-hidden="true"
  >
    <path d="M2.5 12s3.5-6 9.5-6 9.5 6 9.5 6-3.5 6-9.5 6-9.5-6-9.5-6Z" />
    <circle cx="12" cy="12" r="3" />
    {closed ? <path d="M4 4l16 16" /> : null}
  </svg>
);

const Signup = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  // Terms popup
  const [showTermsPopup, setShowTermsPopup] = useState(false);
  const [agreeChecked, setAgreeChecked] = useState(false);

  const navigate = useNavigate();
  const roboman_api = process.env.REACT_APP_ROBOMAN_API;

  const handleGoogleLogin = () => {
    try {
      window.location.href = getGoogleAuthUrl();
    } catch (error) {
      Swal.fire({
        title: "Google Sign-up Unavailable",
        text: error?.message || "Google sign-up is not configured correctly.",
        icon: "error",
        confirmButtonColor: "#2563eb",
      });
    }
  };

  // ----------------------------------
  // ✅ Handle Google redirect: ?code=...
  // ----------------------------------
  // useEffect(() => {
  //   const params = new URLSearchParams(window.location.search);
  //   const code = params.get("code");
  //   const error = params.get("error");

  //   // If Google returned an error
  //   if (error) {
  //     Swal.fire({
  //       title: "Google Sign-in Failed",
  //       text: error,
  //       icon: "error",
  //       confirmButtonColor: "#2563eb",
  //     });

  //     // Clean URL
  //     window.history.replaceState({}, document.title, window.location.pathname);
      
  //     return;
  //   }

  //   // If no auth code, do nothing
  //   if (!code) return;

  //   // We are in Google flow now
  //   setIsGoogleFlow(true);

  //   const exchange = async () => {
  //     try {
  //       Swal.fire({
  //         title: "Signing you up…",
  //         text: "Please wait",
  //         allowOutsideClick: false,
  //         didOpen: () => Swal.showLoading(),
  //       });

  //       const res = await fetch(`${roboman_api}/users/google/exchange`, {
  //         method: "POST",
  //         headers: { "Content-Type": "application/json" },
  //         body: JSON.stringify({ code }),
  //       });

  //       const data = await res.json();

  //       if (!res.ok) {
  //         const msg =
  //           (data && (data.detail || data.message)) ||
  //           "Google signup failed. Please try again.";
  //         throw new Error(typeof msg === "string" ? msg : "Google signup failed.");
  //       }

  //       // Expecting at least: { userId: "..." } (like your signup)
  //       if (data?.userId) {
  //         localStorage.setItem("user_id", data.userId);
  //       }

  //       // ✅ If backend already returns your app JWT token, store it temporarily
  //       // Recommended backend behavior: return { access_token, userId, ... }
  //       if (data?.access_token) {
  //         setPendingGoogleAccessToken(data.access_token);
  //       }

  //       // Clean URL so refresh doesn't re-trigger exchange
  //       window.history.replaceState({}, document.title, window.location.pathname);

  //       // ✅ Open terms popup
  //       setAgreeChecked(false);
  //       setShowTermsPopup(true);

  //       Swal.close();
  //     } catch (e) {
  //       Swal.close();
  //       Swal.fire({
  //         title: "Error!",
  //         text: e?.message || "Google signup failed. Please try again.",
  //         icon: "error",
  //         confirmButtonColor: "#2563eb",
  //       });

  //       // Clean URL
  //       window.history.replaceState({}, document.title, window.location.pathname);
  //     }
  //   };

  //   exchange();
  // }, [roboman_api]);

  // ----------------------------------
  // ✅ After agreeing to Terms
  // ----------------------------------
  const handleAgreeAndContinue = async () => {
    
    // ✅ GOOGLE FLOW:
    // If your /users/google/exchange returns access_token, we can finish login here.
    // if (isGoogleFlow) {
    //   if (pendingGoogleAccessToken) {
    //     localStorage.setItem("access_token", pendingGoogleAccessToken);
    //     localStorage.setItem("isLoggedIn", "true");
    //     navigate("/dashboard");
    //     return;
    //   }

    //   // If backend didn't return access_token, we can't log in automatically here.
    //   Swal.fire({
    //     title: "Almost done!",
    //     text:
    //       "Terms accepted. Please log in to continue (your backend did not return an access token in Google exchange).",
    //     icon: "info",
    //     confirmButtonColor: "#2563eb",
    //   });
    //   navigate("/login");
    //   return;
    // }

    // ✅ EMAIL/PASSWORD FLOW (unchanged)
    try {
      const response = await fetch(`${roboman_api}/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      if (response.ok) {
        const data = await response.json();

        localStorage.setItem("access_token", data.access_token);
        localStorage.setItem("isLoggedIn", "true");

        navigate("/dashboard");
      } else {
        Swal.fire({
          title: "Error!",
          text: "Login failed. Please try logging in manually.",
          icon: "error",
          confirmButtonColor: "#2563eb",
        });
      }
    } catch {
      Swal.fire({
        title: "Error!",
        text: "Something went wrong during login.",
        icon: "error",
        confirmButtonColor: "#2563eb",
      });
    }
  };

  // ----------------------------------
  // ✅ Signup handler (email/password)
  // ----------------------------------
  const handleSignup = async (event) => {
    event.preventDefault();

    if (!email || !password || !confirmPassword) {
      Swal.fire({
        title: "Error!",
        text: "All fields are required.",
        icon: "error",
        confirmButtonColor: "#2563eb",
      });
      return;
    }

    if (password !== confirmPassword) {
      Swal.fire({
        title: "Error!",
        text: "Passwords do not match.",
        icon: "error",
        confirmButtonColor: "#2563eb",
      });
      return;
    }

    try {
      const response = await fetch(`${roboman_api}/signup`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      if (response.ok) {
        const data = await response.json();

        localStorage.setItem("user_id", data.userId);

        setAgreeChecked(false);
        setShowTermsPopup(true);
      } else {
        const errorData = await response.json();
        const messages = Array.isArray(errorData.detail)
          ? errorData.detail.map((item) => item.msg).join(", ")
          : errorData.detail;

        Swal.fire({
          title: "Error!",
          text: messages,
          icon: "error",
          confirmButtonColor: "#2563eb",
        });
      }
    } catch {
      Swal.fire({
        title: "Error!",
        text: "Something went wrong. Please try again.",
        icon: "error",
        confirmButtonColor: "#2563eb",
      });
    }
  };

  return (
    <div className="flex min-h-screen flex-col bg-white overflow-x-hidden">
      <AuthHeader />

      <div className="relative isolate flex-1 overflow-hidden">
        <div className="absolute inset-0 -z-10 bg-gradient-to-b from-indigo-50 via-white to-fuchsia-50" />

        <div className="mx-auto grid max-w-7xl grid-cols-1 lg:grid-cols-12 px-4 sm:px-6 lg:px-8">
          {/* Left panel */}
          <aside className="relative hidden lg:flex lg:col-span-6 items-center py-12">
            <div className="w-full rounded-3xl bg-white ring-1 ring-slate-200 shadow-xl p-12">
              <p className="text-xs tracking-[.25em] font-semibold uppercase text-fuchsia-600/70">
                Roboman
              </p>
              <h1 className="mt-2 text-4xl font-extrabold text-slate-900">
                Create your outreach cockpit
              </h1>
              <p className="mt-3 text-slate-600 max-w-xl">
                AI emails, LinkedIn steps, voice notes, and proposals — all in one place.
              </p>
            </div>
          </aside>

          {/* Right form */}
          <main className="lg:col-span-6 flex items-center py-12">
            <div className="w-full mx-auto max-w-md">
              <div className="rounded-3xl bg-white/90 backdrop-blur-xl shadow-2xl ring-1 ring-slate-200">
                <div className="h-[3px] bg-gradient-to-r from-indigo-600 via-violet-600 to-fuchsia-600" />

                <div className="p-8 sm:p-10">
                  <h2 className="text-2xl font-bold text-center text-slate-900">
                    Sign up
                  </h2>

                  <form className="mt-6 space-y-4" onSubmit={handleSignup}>
                    <input
                      type="email"
                      placeholder="Work email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className="w-full px-4 py-3 rounded-xl border border-slate-200"
                      required
                    />

                    <div className="relative">
                      <input
                        type={showPassword ? "text" : "password"}
                        placeholder="Create password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className="w-full rounded-xl border border-slate-200 px-4 py-3 pr-12"
                        required
                      />
                      <button
                        type="button"
                        onClick={() => setShowPassword((value) => !value)}
                        className="absolute inset-y-0 right-0 flex items-center px-4 text-slate-400 transition hover:text-slate-600"
                        aria-label={showPassword ? "Hide password" : "Show password"}
                      >
                        <EyeIcon closed={showPassword} />
                      </button>
                    </div>

                    <div className="relative">
                      <input
                        type={showConfirmPassword ? "text" : "password"}
                        placeholder="Confirm password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        className="w-full rounded-xl border border-slate-200 px-4 py-3 pr-12"
                        required
                      />
                      <button
                        type="button"
                        onClick={() => setShowConfirmPassword((value) => !value)}
                        className="absolute inset-y-0 right-0 flex items-center px-4 text-slate-400 transition hover:text-slate-600"
                        aria-label={showConfirmPassword ? "Hide password" : "Show password"}
                      >
                        <EyeIcon closed={showConfirmPassword} />
                      </button>
                    </div>

                    <button
                      type="submit"
                      className="w-full py-3 rounded-xl font-semibold text-white bg-gradient-to-r from-indigo-600 via-violet-600 to-fuchsia-600"
                    >
                      Sign Up
                    </button>
                  </form>


                 {/* social login */}

                  <div className="my-6 flex items-center gap-3">
                    <div className="h-px flex-1 bg-slate-200" />
                    <span className="text-xs text-slate-500">or continue with</span>
                    <div className="h-px flex-1 bg-slate-200" />
                  </div>

                  <div className="flex justify-center gap-4">
                    <button
                      type="button"
                      onClick={handleGoogleLogin}
                      className="h-11 w-11 rounded-full ring-1 ring-slate-200 bg-white shadow-sm hover:bg-slate-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500"
                      aria-label="Sign in with Google"
                    >
                      <img
                        src="https://cdn-icons-png.flaticon.com/512/300/300221.png"
                        alt="Google"
                        className="mx-auto h-5 w-5"
                      />
                    </button>

                    <button
                      type="button"
                      onClick={() => (window.location.href = `${roboman_api}/login/linkedin`)}
                      className="h-11 w-11 rounded-full ring-1 ring-slate-200 bg-white shadow-sm opacity-60 cursor-not-allowed"
                      aria-label="Sign in with LinkedIn"
                    >
                      <img
                        src="https://cdn-icons-png.flaticon.com/512/174/174857.png"
                        alt="LinkedIn"
                        className="mx-auto h-5 w-5"
                      />
                    </button>

                    <button
                      type="button"
                      onClick={() => (window.location.href = `${roboman_api}/login/microsoft`)}
                      className="h-11 w-11 rounded-full ring-1 ring-slate-200 bg-white shadow-sm opacity-60 cursor-not-allowed"
                      aria-label="Sign in with Microsoft"
                    >
                      <img
                        src="https://cdn-icons-png.flaticon.com/512/732/732221.png"
                        alt="Microsoft"
                        className="mx-auto h-5 w-5"
                      />
                    </button>
                  </div>

                  <p className="mt-6 text-center text-sm text-slate-600">
                    Already have an account?{" "}
                    <button
                      type="button"
                      onClick={() => navigate("/login")}
                      className="font-semibold text-indigo-600"
                    >
                      Sign In
                    </button>
                  </p>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>

      {/* ✅ Terms & Conditions Popup */}
      {showTermsPopup && (
        <TermsPopup
          agreeChecked={agreeChecked}
          setAgreeChecked={setAgreeChecked}
          onAgree={handleAgreeAndContinue}
        />
      )}
    </div>
  );
};

export default Signup;
